(function(document, window, $) {
    'use strict';

    var Site = window.Site;

    $(document).ready(function($) {

        var modalPageChange = false;
        var modalPageSelectedId = [];

        window.filterModalUnbindEvents = function () {
            $('#filtermodal input, #filtermodal select').unbind('change');
        };

        window.filterModalBindEvents = function () {
            $('#filtermodal input, #filtermodal select').change(function () {
                window.makeModalFilterRequest();

            });
        }

        window.initModalFilterOnChange = function () {
            filterModalUnbindEvents();
            filterModalBindEvents();
        }

        //select all

        $(document).on('click','#filtermodal-result .selectable-all', function(e){
            var table= $(e.target).closest('table');
            $('td input:checkbox',table).prop('checked',this.checked).trigger('change');
        });

        $(document).on('change','#filtermodal-result .selectable-item', function(e){
            if ($(this).prop('checked')){
                addToSelected($(this).prop('value'));
            }else{
                removeFromSelected($(this).prop('value'));
            };
        });

        function removeFromSelected(id)
        {
            modalPageSelectedId = $.grep(modalPageSelectedId, function(value) {
                return value != id;
            });

            updateSelectedCount();
        }

        function addToSelected(id)
        {
            if ($.inArray(id, modalPageSelectedId) == -1) {
                modalPageSelectedId.push(id);
            }
            updateSelectedCount();
        }

        function checkSelected()
        {
            $('#filtermodal-result .selectable-item').each(function(){
                if ($.inArray($(this).prop('value'), modalPageSelectedId) != -1){
                    $(this).prop('checked', true);
                }
            });
            updateSelectedCount();
        }

        function updateSelectedCount()
        {
            $('.modal-selected-count').html(modalPageSelectedId.length);
        }

        window.getModalSelected = function()
        {
            return modalPageSelectedId;
        }

        window.resetModalPageSelected = function()
        {
            modalPageSelectedId = [];
            updateSelectedCount();
        }




        //Pagination
        $(document).on('click','#filtermodal-result .pagination a', function(e){
            e.preventDefault();
            var href= $(this).attr('href');
            //for this next line will do the trick but is not suggested to be used anywhere else
            var page=href.split('page=')[1];
            //location.hash = "#page=" + page;
            // location.replace("#page=" + page);
            modalPageChange = true;
            $('#filtermodal input[name=page]').val(page).trigger("change");

        });

        window.initFilterModal = function() {
            var filter = $('#filtermodal');
            window.resetModalPageSelected();

            if (!filter.length) return;

            window.filterModalBindEvents();

            var $panel = $('#filtermodal-result');
            var $panelSelected = $('#filtermodal-result .panel-selected');

            var filtering = true;
            var filter_in_progress = false;



            $panel.sortableNav();



            var mode = 'list';
            var md = $('#mode');
            if (md.length) mode = md.val();

            $('#filtermodal').submit(function (event) {
                if (filtering) {
                    event.preventDefault();
                    makeModalFilterRequest();
                }
            });



            $('#filtermodal').on('filtermodal:nofiltering', function () {
                filtering = false;
            });

            $('#filtermodal').on('filtermodal:filtering', function () {
                filtering = true;
            });

            $('#filtermodal').on('filtermodal:pagechange', function () {
                modalPageChange = true;
            });


            window.makeModalFilterRequest = function() {


                if (!filtering) return;
                //reset the page to 1 if there is a filter change
                if (!modalPageChange) {
                    $('input[name=page]').val(1);
                    window.resetModalPageSelected();
                }
                modalPageChange = false;


                $panel.find('.panel-body .content').html('');

                var url = filter.attr('data-href');
                if (filter_in_progress && $xhr != undefined) $xhr.abort();

                filter_in_progress = true;
                $panel.css('opacity','0.3');
                var $xhr = $.post(url, filter.serialize())
                        .done(function (data) {
                            if (mode == 'list') {
                                $panel.find('.panel-body').html(data);
                                $panel.css('opacity','1');
                                $('#filtermodal-result').trigger('filter:done');
                                $( document).trigger( "enhance.tablesaw" );
                            } else {
                                window[mode + 'DataHandler'](data);
                            }
                        })
                        .fail(function () {
                            $panel.find('.panel-body .content').html();
                        })
                        .always(function () {
                            filter_in_progress = false;
                            checkSelected();
                        })
                    ;
            }

            //trigger first load
            if (mode == 'list') {

                modalPageChange = true;
                makeModalFilterRequest();
            }



            //paging
            var paging = $('#filtermodal input[name=limit]').val();
            $('#filtermodal-result .paging [data-paging=' + paging + ']').addClass('active');

            $('#filtermodal-result .paging a').on('click', function () {
                $('#filtermodal-result .paging a.active').removeClass('active');
                $(this).addClass('active');
                $('input[name=limit]').val($(this).attr('data-paging')).trigger("change");
            });
        }


    });


})(document, window, jQuery);
